import store from '@store';
import {
  assetsUrl,
  duration,
  localDate,
  fAlamat,
  isArray,
  isObject,
  getDeepObj,
  arrayToObject,
  currency,
} from '@utils/format';

export default {
  data() {
    return {
      M_COLOR: {
        1: 'success',
        2: 'blue',
        3: 'purple ',
        4: 'pink',
        5: 'indigo',
      },
    };
  },
  methods: {
    $imgUrl: (url) => (url ? assetsUrl(url) : ''),

    $allow(akses, policy) {
      // cek jika tidak ada akses
      if (!akses || (akses && typeof akses === 'boolean')) return typeof akses === 'boolean' ? akses : true;

      // jika ada ambil preferensi akses
      const akseses = store.getters['preferensi/akseses'] || [];

      let allow = false;
      const pathAkses = akses && typeof akses === 'string' && akses.split('|');
      if (pathAkses.length) {
        pathAkses.forEach((path) => {
          if (allow) return;
          if (!allow && policy) {
            allow =
              !path || path === 'true' || ((akseses || []).filter((item) => item === path).length > 0 && policy[path]);
          } else if (!allow && !policy) {
            allow = !path || path === 'true' || (akseses || []).filter((item) => item === path).length > 0;
          }
        });
      }

      return allow;
    },

    $downloadFile(sUrl) {
      // Creating new link node.
      const link = document.createElement('a');
      link.href = sUrl;

      // Dispatching click event.
      // if (document.createEvent) {
      //   const e = document.createEvent('MouseEvents')
      //   e.initEvent('click', true, true)
      //   link.dispatchEvent(e)
      //   return true
      // }
      window.open(sUrl);
      return true;
    },

    $durasi(start, end, options) {
      return duration(start, end, options);
    },

    $localDate(date, short, withTime, usingNumber) {
      if (!date) return '-';
      return localDate(date, short, withTime, usingNumber);
    },

    $fAlamat(data) {
      return fAlamat(data);
    },

    $fGender(data) {
      return data === 'L' ? 'Laki - laki' : data === 'P' ? 'Perempuan' : '-';
    },

    $isObject(data) {
      return isObject(data);
    },

    $getDeepObj(obj, desc) {
      return getDeepObj(obj, desc);
    },

    $getAttr(obj, data) {
      return getDeepObj(obj, `attributes.${data}`);
    },

    $getRelasi(obj, data) {
      return getDeepObj(obj, `relationships.${data}.data`);
    },

    $getIncluded(type, value, respon) {
      const included = respon || this.included || [];
      const data = included.filter((item) => item.type === type && Number(item.id) === Number(value));
      return (data && data[0]) || {};
    },

    $getItem(item, value) {
      return item.filter((obj) => Number(obj.id) === Number(value))[0] || {};
    },

    $getLabelOpt(options, value) {
      const opt = options.find((item) => item.value === value || '') || {};
      return (opt && opt.label) || '-';
    },

    $isAktif(data) {
      const akunAktif = this.$getAttr(data, 'is_aktif');
      const keterangan = Number(this.$getAttr(data, 'is_aktif')) === 1 ? 'Aktif' : 'Diblokir';
      const icon = Number(this.$getAttr(data, 'is_aktif')) === 1 ? 'mdi-check-circle' : 'mdi-close-circle';
      return { value: akunAktif, text: keterangan, icon };
    },

    $isVerifikasi(data) {
      const akunAktif = this.$getAttr(data, 'is_verifikasi');
      const keterangan = Number(this.$getAttr(data, 'is_verifikasi')) === 1 ? 'Sudah Verifikasi' : 'Belum Verifikasi';
      const icon = Number(this.$getAttr(data, 'is_verifikasi')) === 1 ? 'mdi-check-circle' : 'mdi-close-circle';
      return { value: akunAktif, text: keterangan, icon };
    },

    $mapForMaster(data, text = false) {
      // cek type data
      let temp = [];
      if (data && isObject(data)) {
        for (let key in data) {
          temp.push({
            text: data[key],
            value: text ? data[key] : Number(key),
          });
        }
      } else if (data && isArray(data)) {
        temp = data.map((value) => {
          return {
            text: value,
            value: value,
          };
        });
      }
      return temp;
    },

    $wordCount(kalimat) {
      if (!kalimat) return 0;
      let katas = kalimat.replace(/[^a-zA-Z0-9'\s]/g, '');
      katas = katas.replace(/\s+/g, ' ');
      // filter kata jika ada character selain digit dan letter
      const temp = katas.trim();
      const count = temp.split(' ');
      return count.length;
    },

    $currency(data) {
      return (data && currency(data)) || '-';
    },

    $isNull(data) {
      return typeof data === 'object' && data === null;
    },

    $arrToObj(array, key) {
      return arrayToObject(array, key);
    },

    $validateFileSize(file, maxSizeInMB = 2) {
      if (!file) return true;
      const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        return {
          valid: false,
          message: `Ukuran berkas terlalu besar. Maksimal ${maxSizeInMB} MB.`,
        };
      }
      return { valid: true };
    },
  },
};
